import { Component, inject } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faBars, faXmark } from '@fortawesome/free-solid-svg-icons';
import { RouterLink } from '@angular/router';
import { MobileNavigationService } from '../main-menu/mobile-navigation.service';

@Component({
  selector: 'app-main-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.scss'],
  imports: [
    RouterLink,
    FontAwesomeModule,
  ],
  standalone: true
})
export class MainHeaderComponent {
  private readonly mobileNavigationService = inject(MobileNavigationService);

  protected readonly faBars = faBars;
  protected readonly faXmark = faXmark;

  protected get isMobileMenuOpen(): boolean {
    return this.mobileNavigationService.isOpen();
  }

  protected handleBrandNavigation(): void {
    if (this.isMobileMenuOpen) {
      this.mobileNavigationService.close();
    }
  }

  protected toggleMobileMenu(): void {
    this.mobileNavigationService.toggle();
  }
}
